import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { SunMedium } from 'lucide-react';
import { useLms } from '../context/LmsContext';
import heroImage from '../assets/abundio-login-hero-campus-solar.png';
import { defaultDashboard } from '../utils/navigation';

export default function Login() {
  const { currentUser, login, storageStatus } = useLms();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  if (currentUser) return <Navigate to={defaultDashboard(currentUser.role)} replace />;

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    const result = await login(form);
    if (!result.ok) {
      setError(result.message);
      return;
    }
    navigate(location.state?.from || defaultDashboard(result.user.role), { replace: true });
  };

  return (
    <div className="login-page abundio-login-page">
      <section className="login-panel">
        <div className="login-brand abundio-login-brand">
          <span className="login-logo"><SunMedium size={34} /></span>
          <div>
            <h1>Abundio Academy</h1>
          </div>
        </div>
        <form onSubmit={submit} className="login-form">
          <label>Email<input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></label>
          <label>Password<input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></label>
          {error && <div className="form-error">{error}</div>}
          {storageStatus?.error && <div className="form-error">{storageStatus.error}</div>}
          <button className="button button-primary full" type="submit">Log in</button>
        </form>
      </section>
      <aside className="login-aside solar-login-visual" aria-label="Top view university rooftop with solar panels" style={{ backgroundImage: `linear-gradient(135deg, rgba(6, 23, 35, 0.22), rgba(6, 23, 35, 0.10)), url(${heroImage})` }} />
    </div>
  );
}
